import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import * as amplitude from '@amplitude/unified';
import { AMPLITUDE } from './constants';

const useAmplitude = () => {
    const auth0 = useAuth0();
    useEffect(() => {
        const userId = auth0.user?.sub;
        const email = auth0.user?.email;
        if (!AMPLITUDE.API_KEY.startsWith('{') && auth0.isAuthenticated && userId && email) {
            amplitude.initAll(AMPLITUDE.API_KEY, {
                analytics: { autocapture: true },
                sessionReplay: { sampleRate : 1 }
            }).then(() => {
                amplitude.setUserId(userId);
                amplitude.identify(new amplitude.Identify().set('email', email));
            });
        }
    }, [auth0.isAuthenticated, auth0.user?.sub, auth0.user?.email]);
};

export default useAmplitude;
